import PurchaseContainer from "@features/dashboard/components/PurchaseContainer";
import type { ProductType } from "@memorang/types";
import { useLocalSearchParams } from "expo-router";
const PurchaseRoute = () => {
	const { productType, explicitProductNumericId, explicitProductId } =
		useLocalSearchParams<{
			productType: ProductType;
			explicitProductNumericId: string;
			explicitProductId?: string;
		}>();

	return (
		<PurchaseContainer
			productType={productType}
			explicitProductNumericId={Number(explicitProductNumericId)}
			explicitProductId={explicitProductId}
		/>
	);
};

export default PurchaseRoute;
